import { createSlice } from '@reduxjs/toolkit';

const tokenSlice = createSlice({
  name: 'token',
  initialState: {
    idToken: null,
    expiresAt: null,
    isRefreshing: false,
  },
  reducers: {
    setToken: (state, action) => {
      // console.log('!!!!!! setToken redux/token.slice.js:', action.payload === state.idToken ? 'no change' : 'new token')
      state.idToken = action.payload;
    },
    setExpiresAt: (state, action) => {
        // console.log('!!!!!! expiresAt redux/token.slice.js:', action.payload)
        state.expiresAt = action.payload;
      },
    setIsRefreshing: (state, action) => {
      state.isRefreshing = action.payload;
    },
    clearToken: (state) => {
      state.idToken = null;
      state.expiresAt = null;
    },
  },
});

export const { setToken, setExpiresAt, setIsRefreshing, clearToken } = tokenSlice.actions;
export default tokenSlice.reducer;